import './style.scss';

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

// eslint-disable-next-line no-unused-vars
const setSwiper = (Swiper) => {

    

    const productDetails = document.getElementsByClassName('wp-block-tmg-blocks-product-details');

    if (!productDetails || productDetails.length === 0) return;

    [...productDetails].forEach((elem, index) => {
        const id = elem.id;

        const selectorId = id ? '#' + id + ' ' : '';
        
        // eslint-disable-next-line no-unused-vars
        const selector = selectorId + '.related-product-list';

        // eslint-disable-next-line no-unused-vars
        const option = {
            slidesPerView: 1,
            enabled: true,
            pagination: {  //ページネーションを表示
                el: selectorId + '.swiper-pagination',
                clickable: true,  //アイコンをクリックすると対応するスライドに移動
            },

            navigation: {  //ナビゲーションボタンを表示
                nextEl: selectorId + '.swiper-button-next',
                prevEl: selectorId + '.swiper-button-prev',
            },
            breakpoints: {
                769: {
                    enabled: false,
                    slidesPerView: 0,
                },
            },
        }

        // init Swiper:
        // eslint-disable-next-line no-unused-vars
        // const swiper = new Swiper(selector, option);
        eval("const swiper_" + index + "= new Swiper(selector, option);");
    })
}
setSwiper(Swiper);

